export const groupRoutes = (routes) => {
    if (!routes || !Array.isArray(routes)) return [];
    const grouped = [];
    const processedIds = new Set();

    routes.forEach(route => {
        if (processedIds.has(route._id)) return;

        // Ensure we check string endsWith securely
        const nameStr = route.name || '';
        const isMorning = route.type === 'morning';
        const isAfternoon = route.type === 'afternoon';

        if (isMorning || isAfternoon) {
            const siblingType = isMorning ? 'afternoon' : 'morning';
            const baseName = nameStr.replace(/\s*\((Morning|Afternoon)\)$/i, '');
            const siblingNameWithSuffix = `${baseName} (${siblingType.charAt(0).toUpperCase() + siblingType.slice(1)})`;
            
            const sibling = routes.find(r => 
                r.type === siblingType && 
                (r.name === nameStr || r.name === siblingNameWithSuffix || r.name.replace(/\s*\((Morning|Afternoon)\)$/i, '') === baseName) &&
                !processedIds.has(r._id) &&
                (r.schoolId?._id || r.schoolId) === (route.schoolId?._id || route.schoolId)
            );

            if (sibling) {
                const morningRoute = isMorning ? route : sibling;
                const afternoonRoute = isAfternoon ? route : sibling;
                
                processedIds.add(morningRoute._id);
                processedIds.add(afternoonRoute._id);

                grouped.push({
                    ...morningRoute,
                    _id: `merged_${morningRoute._id}_${afternoonRoute._id}`,
                    isMerged: true,
                    morningRoute,
                    afternoonRoute,
                    name: baseName,
                    type: 'morning_afternoon',
                    driverId: morningRoute.driverId || afternoonRoute.driverId,
                    schoolId: morningRoute.schoolId || afternoonRoute.schoolId,
                    children: morningRoute.children || afternoonRoute.children,
                    paId: morningRoute.paId || afternoonRoute.paId,
                    status: (morningRoute.status === 'completed' && afternoonRoute.status === 'completed') ? 'completed' 
                            : (morningRoute.status === 'completed' && afternoonRoute.status !== 'completed') ? 'morning_completed'
                            : (afternoonRoute.status === 'completed' && morningRoute.status !== 'completed') ? 'afternoon_completed'
                            : (morningRoute.status === 'started' || afternoonRoute.status === 'started') ? 'started'
                            : morningRoute.status,
                    completionStatus: morningRoute.completionStatus || afternoonRoute.completionStatus,
                    completionNote: morningRoute.completionNote || afternoonRoute.completionNote,
                    isActive: morningRoute.isActive || afternoonRoute.isActive,
                });
                return;
            }
        }
        
        processedIds.add(route._id);
        grouped.push(route);
    });

    return grouped;
};
